module.exports = __webpack_public_path__ + "img/battery-new.11549844.svg";